/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const createc_floralis_luminaria_zona4 = (block) => {
  const estado = block.getFieldValue('STAT');
  return `floralis_LuminariaCalle(${estado});\n`;
};

export const createc_floralis_lights = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.floralis = 'checkFlor();\n';
  return `prenderLucesFlor(${color});\n`;
};

export const createc_floralis_lights_off = (block, generator) => {
  generator.loop_footer_.floralis = 'checkFlor();\n';
  return 'apagarLucesFlor();\n';
};

export const createc_floralis_reflector = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.floralis_ref = 'checkReflectores();\n';
  return `prenderLucesReflectores(${color});\n`;
};

export const createc_floralis_reflector_off = (block, generator) => {
  generator.loop_footer_.floralis_ref = 'checkReflectores();\n';
  return 'apagarLucesReflectores();\n';
};

export const createc_floralis_restore_petal = () => 'RepararPetalo();\n';

export const createc_floralis_open_petal = (block, generator) => {
  const estado = block.getFieldValue('STAT');
  generator.loop_footer_.createc_floralis_open_petal = '\n  floralis_checkMovimientoFlor();\n';
  return `\n${estado === 'HIGH' ? 'AbrirFlor();' : 'CerrarFlor();'}\n`;
};
